import React from 'react'
import Image from '../../atoms/image/Image'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import ResultsTable from './table/ResultsTable'

import Trophy from '../../../assets/results/award.gif'
import Card from '../../atoms/card/Card'

interface Props {
  data: ModelAPI.Reporting.ReportingTeams[]
}

const RoundResultsTeamSummary: React.FC<Props> = ({ data }) => {
  const teamPairs = data.filter(t => !t.isCpuTeam).reduce<Array<Array<ModelAPI.Reporting.ReportingTeams>>>(function(result, value, index, array) {
    if (index % 2 === 0)
      result.push(array.slice(index, index + 2))
    return result
  }, [])
  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-2'>Team Summary</Text>
      <InlineGroup fullHeight>
        <Card wide sharp padding={0}>
          <InlineGroup spaceLeft={2} fullHeight block>
            <InlineGroup verticalCenter center className='width-25-percent'>
              <Image src={Trophy} alt='Trophy' size={72}/>
            </InlineGroup>

            <ResultsTable id='team_summary' noborder>
              <tbody>
                {teamPairs.map((pair, i) => {
                  return (
                    <tr key={i}>
                      <td>{pair[0].teamName}</td>
                      <td>{pair[1]?.teamName}</td>
                    </tr>
                  )
                })}
              </tbody>
            </ResultsTable>
          </InlineGroup>
        </Card>
      </InlineGroup>
    </VerticalGroup>
  )
}

export default RoundResultsTeamSummary

